import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { usePlaylistStore } from '@/store/playlist/store';
import { DarkMembersPandaView } from '@/components/playlist/preview/DarkMembersPandaView';

export default function DarkMembersModule() {
  useLanguage();
  const { hash, moduleId } = useParams<{ hash: string; moduleId: string }>();
  const navigate = useNavigate();
  const { getPlaylistByHash } = usePlaylistStore();

  const playlist = hash ? getPlaylistByHash(hash) : null;
  const module = playlist?.darkMembersSettings?.modules
    .filter(m => m.isActive)
    .find(m => m.id === moduleId);

  if (!playlist || !module || playlist.template !== 'dark-members') {
    return (
      <div className="min-h-screen bg-[#0E0E0E] flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-white text-2xl font-bold mb-2">
            {translateInterfaceText("Módulo não encontrado")}</h1>
          <p className="text-gray-400">
            {translateInterfaceText("Verifique se o link está correto.")}</p>
        </div>
      </div>
    );
  }

  const handleBack = () => {
    navigate(`/members/${hash}`);
  };

  return (
    <DarkMembersPandaView 
      module={module}
      onBack={handleBack}
    />
  );
}
